import './App.css';
import wx from './data/wx.js';
import Header from "./components/Header.jsx";
import * as React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics } from "@vercel/analytics/react";
import Navigation from './components/Navigation.jsx';
import HomePage from './pages/HomePage.jsx';
import CreateVspeedPage from './pages/CreateVspeedPage.jsx';
import NavLogPage from './pages/NavLogPage.jsx';
import WeatherPage from './pages/WeatherPage.jsx';
import HomePageWtBal from './pages/HomePageWtBal.jsx';
import CreateWeightBalancePage from './pages/CreateWeightBalancePage.jsx';
import RolloutPage from './pages/RolloutPage.jsx';
import EditRollPage from './pages/EditRollPage.jsx';
import Footer from "./components/Footer.jsx";
import EditWtbalPage from './pages/EditWtbalPage.jsx';
import VspPage from './pages/VspPage.jsx';
import EditVspPage from './pages/EditVspPage.jsx';
import EditEnvelopePage from './pages/EditEnvelopePage.jsx';
import CreateAirplanePage from './pages/CreateAirplanePage.jsx';
import EditFuelArmPage from './pages/EditFuelArmPage';
import AboutPage from "./pages/AboutPage.jsx";
import ContactPage from "./pages/ContactPage.jsx";
import PrivacyPolicyPage from './pages/PrivacyPolicyPage.jsx';
import DisclaimerPage from "./pages/DisclaimerPage";
import DensityAltPage from "./pages/DensityAltPage.jsx";
import CrosswindPage from "./pages/CrosswindPage.jsx";
import Maneuverpage from "./pages/Maneuverpage.jsx";
import AirframePowerplantPage from "./pages/AirframePowerplantPage.jsx";
import AirplanePrebuyPage from "./pages/AirplanePrebuyPage.jsx";
import lessons from './data/lessons.js';
import AdjustableAmortizationPage from './pages/AdjustableAmortizationPage.jsx';
import {
  getAdminSecret,
  setAdminSecret,
  clearAdminSecret
} from "./ownerSecret";


// import state hooks
import { useState } from 'react';

function App() {
  const [vspToEdit, setVspeedToEdit] = useState({
    name: '',
    config: '',
    Vsp1: '',
    Vsp2: '',
    unit: ''
  });
  const [wtbalToEdit, setWtbalToEdit] = useState([]);
  const [rollToEdit, setRollToEdit] = useState([]);

  // current aircraft selected
  const [currentAircraft, setCurrentAircraft] = useState({
    tailNumber: '',
    makeModel: '',
    engine: '',
    imageUrl: ''   // Storage URL (or thumbUrl if you prefer)
  });

  const [isAdminMode, setIsAdminMode] = useState(
  Boolean(getAdminSecret())
);

const handleAdminLogin = () => {
  const secret = window.prompt("Enter the administrator secret:");

  if (!secret || !secret.trim()) {
    return;
  }

  setAdminSecret(secret.trim());
  setIsAdminMode(true);

  alert(
    "Administrator mode is enabled for this browser session. " +
    "The server will verify the secret when you save a change."
  );
};

const handleAdminLogout = () => {
  clearAdminSecret();
  setIsAdminMode(false);
  alert("Administrator mode has been disabled.");
};

  return (
    <div className="App_router">
      <Router>
        <Header currentAircraft={currentAircraft} />

        <Navigation />
        <div className="admin-login-bar">
            {isAdminMode ? (
              <>
                <span className="admin-status">
                  Administrator mode enabled
                </span>

                <button
                  type="button"
                  className="admin-login-button"
                  onClick={handleAdminLogout}
                >
                  Admin Logout
                </button>
              </>
            ) : (
              <button
                type="button"
                className="admin-login-button"
                onClick={handleAdminLogin}
              >
                Admin Login
              </button>
            )}
          </div>

        <main>
          <Routes>
            <Route 
            path="/" 
            element={
            <HomePage 
              setVspeedToEdit={setVspeedToEdit} 
              setCurrentAircraft={setCurrentAircraft}
              />
              } 
              />
            <Route
              path="/home-page"
              element={
                <HomePage
                  setVspeedToEdit={setVspeedToEdit}
                  setCurrentAircraft={setCurrentAircraft}
                />
              }
            />
            <Route
              path="/vs-page"
              element={
                <HomePage
                  setVspeedToEdit={setVspeedToEdit}
                  setCurrentAircraft={setCurrentAircraft}
                />
              }
            />
            <Route
              path="/aircraft/create"
              element={<CreateAirplanePage />}
            />
            <Route path="/add-vspeed" element={<CreateVspeedPage />} />
            <Route
              path="/navlog"
              element={<NavLogPage currentAircraft={currentAircraft} />}
            />
            <Route
              path="/rollout"
              element={<RolloutPage
                setRollToEdit={setRollToEdit}
                currentAircraft={currentAircraft}
              />}
            />
            <Route
              path="/edit-roll/:id"
              element={<EditRollPage rollToEdit={rollToEdit} currentAircraft={currentAircraft} />}
            />
            
            
            <Route
                path="/add-wtbal"
                element={<CreateWeightBalancePage currentAircraft={currentAircraft} />}
              />
            <Route
                path="/edit-envelope"
                element={<EditEnvelopePage currentAircraft={currentAircraft} />}
              />
            <Route
                path="/wtbals/create/:tail"
                element={<CreateWeightBalancePage currentAircraft={currentAircraft} />}
              />
            <Route
              path="/wtbals"
              element={<HomePageWtBal
                setWtbalToEdit={setWtbalToEdit}
                currentAircraft={currentAircraft}
              />}
            />
            <Route
                path="/edit-wtbal"
                element={
                  <EditWtbalPage
                    wtbalToEdit={wtbalToEdit}
                    currentAircraft={currentAircraft}
                  />
                }
              />

              <Route
                path="/edit-fuel-arm"
                element={
                  <EditFuelArmPage
                    wtbalToEdit={wtbalToEdit}
                    currentAircraft={currentAircraft}
                  />
                }
              />
            <Route path="/weather" element={<WeatherPage wx={wx} />} />
            <Route
              path="/mnvr"
              element={<Maneuverpage lessons={lessons} />}
            />
            <Route
              path="/vsps"
              element={<VspPage
                setVspToEdit={setVspeedToEdit}
                currentAircraft={currentAircraft}
              />}
            />
            <Route
              path="/edit-vsp/:id"
              element={<EditVspPage vspToEdit={vspToEdit} currentAircraft={currentAircraft} />}
            />
            <Route path="/disclaimer" element={<DisclaimerPage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/density-altitude" element={<DensityAltPage />} />
            <Route path="/cw" element={<CrosswindPage />} />
            
            <Route 
               path="/airframe-powerplant" 
               element={<AirframePowerplantPage 
               currentAircraft={currentAircraft} 
               setCurrentAircraft={setCurrentAircraft} 
               />} />
            <Route 
               path="/airplane-prebuy" 
               element={<AirplanePrebuyPage currentAircraft={currentAircraft} setCurrentAircraft={setCurrentAircraft} />} />
          
          <Route
              path="/adjustable-amortization"
              element={<AdjustableAmortizationPage />}
            />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>

        <footer>
           <div style={{marginTop: "10px", fontSize: "14px", color: "#666"}}>
              &copy;2026. toldcardapp.com. All rights reserved.
          </div>
          <div 
          style={{marginTop: "20px",
          }}>
          <div >
            <Footer />
          </div>
        </div>

        </footer>
      </Router>
      <Analytics />
    </div>
  );
}

export default App;
